<template>
  <div>
    <Header />
    <main role="main" class="text-center bg-white">
      <!-- <b-container v-if="user.id">
        <b-row v-if="statusPay !== 2" class="align-items-center mb-2" id="register-cong-thi-thu">
          <b-col xs="12" class="mt-3">
            <img style="max-width: 100%" :src="link" alt="qrcode chuyển tiền">
          </b-col>
          <b-col xs="12" class="mt-3">
            <div class="des-price">
              <div>Bạn chưa đăng ký tham gia cổng thi thử.</div>
              <div>Quét mã QR Code bên cạnh để thanh toán.</div>
              <div class="loader"></div>
              <div v-if="statusPay === 0">Đang chờ thanh toán</div>
              <div v-if="statusPay === 1">Đang chờ xác nhận</div>
              <button v-if="statusPay === 0" class="btn btn-sm btn-primary btn-pay"
                :disabled="statusPay === 1 || statusPay === 3" @click="handleCheck">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-smartphone-nfc">
                  <rect width="7" height="12" x="2" y="6" rx="1" />
                  <path d="M13 8.32a7.43 7.43 0 0 1 0 7.36" />
                  <path d="M16.46 6.21a11.76 11.76 0 0 1 0 11.58" />
                  <path d="M19.91 4.1a15.91 15.91 0 0 1 .01 15.8" />
                </svg>
                <span>Đã chuyển khoản</span>
              </button>
              <div v-if="statusPay === 1" style="font-size: x-small">Quá trình xác nhận sẽ mất một ít thời gian. Nếu quá
                5p, vui lòng liên hệ số điện thoại: 0862.783.370 để được xác nhận</div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="statusPay === 2">
          <b-col xs="12" class="mt-3">
            <div class="main-exam-menu">
              <div class="exam-container-menu">
                <router-link v-for="menu in menus" :key="menu.img" :to="{ name: menu.route }" class="item-exam"
                  :class="{ active: $route.name == menu.route }">
                  <img v-if="$route.name == menu.route" :src="require('@/assets/images/testing/' + menu.img_active)">
                  <img v-else :src="require('@/assets/images/testing/' + menu.img)">
                  <br>
                  <span>{{ menu.name }}</span>
                </router-link>
              </div>
            </div>
            <div class="main-exam-right">
              <slot />
            </div>
          </b-col>
        </b-row>
      </b-container> -->
      <b-container>
        <b-row>
          <b-col xs="12" class="mt-3">
            <div class="main-exam-menu">
              <div class="exam-container-menu">
                <router-link v-for="menu in menus" :key="menu.img" :to="{ name: menu.route }" class="item-exam"
                  :class="{ active: $route.name == menu.route }">
                  <img v-if="$route.name == menu.route" :src="require('@/assets/images/testing/' + menu.img_active)">
                  <img v-else :src="require('@/assets/images/testing/' + menu.img)">
                  <br>
                  <span>{{ menu.name }}</span>
                </router-link>
              </div>
            </div>
            <div class="main-exam-right">
              <slot />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { mapState } from 'vuex'
import { checkResponse, get, post } from "@/utils/http";
import { APP_CONFIG } from "@/utils/constants";

export default {
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapState('auth', ['user']),
    link() {
      return `https://img.vietqr.io/image/MB-9704229209012738746-compact2.png?amount=20000&addInfo=${this.user.id} ${this.user.phone} dk cong thi thu ${this.statusTikTok ? 'tiktok' : 'bt'}&accountName=NGUYEN%20VAN%20ANH`
    }
  },
  methods: {
    getUserDeposits() {
      return get(`${APP_CONFIG.apiUrl}/deposits`).then(checkResponse);
    },
    postDeposit(data) {
      return post(`${APP_CONFIG.apiUrl}/deposits`, data).then(checkResponse);
    },
    tryCheckAction() {
      return new Promise((resolve) => {
        this.getUserDeposits().then((res) => {
          console.log(res.data.data);
          resolve(res.data.data.findIndex(f => f.amount >= 20000 && f.status === "Hoàn thành"));
        })
      });
    },
    tryCheck() {
      if (!document.getElementById('register-cong-thi-thu')) return;
      this.tryCheckAction().then((idx) => {
        if (idx === -1) {
          setTimeout(() => {
            this.tryCheck();
          }, 4000);
        } else {
          this.statusPay = 2;
        }
      });
    },
    handleCheck() {
      this.statusPay = 3;
      this.postDeposit({
        type: 1,
        amount: 20000
      }).then(() => {
        this.statusPay = 1;
      });
    }
  },
  mounted() {
    // var x = window.localStorage.getItem("tiktok");
    // this.statusTikTok = ["1", 1].includes(x);
    // setTimeout(() => {
    //   if (this.user.id) {
    //     this.tryCheck();
    //   }
    // }, 1000);
  },
  data() {
    return {
      statusTikTok: 0,
      statusPay: 0,
      menus: [
        {
          name: 'Xếp hạng',
          route: 'thi-thu-xep-hang',
          img: 'rank-gray.png',
          img_active: 'rank-active.png'
        },
        {
          name: 'Phòng thi',
          route: 'thi-thu',
          img: 'exam1-gray.png',
          img_active: 'exam1.png',
        },
        {
          name: 'Lịch sử thi',
          route: 'thi-thu-lich-su',
          img: 'exam2-gray.png',
          img_active: 'exam2.png',
        }
      ],
    }
  },
}
</script>



<style lang="scss">
.btn-pay {
  display: flex;
  align-items: center;
  gap: 5px;
}

.btn-pay svg {
  display: flex;
}

.des-price {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.loader {
  border: 5px solid #f3f3f3;
  /* Light grey */
  border-top: 5px solid #11202a;
  /* Blue */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin .5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.main-exam-menu {
  width: 100%;
  float: left;
  padding: 30px 0 20px 0;

  .exam-container-menu {
    width: 350px;
    margin: 0 auto;
    height: 130px;
    background: #fff;
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .item-exam {
      padding: 25px 5px 10px 5px;
      width: 100px;
      text-align: center;
      color: #999;
      border: 1px solid #DDD;
      border-radius: 4px;
      text-decoration: none;

      img {
        height: 40px;
        margin-bottom: 10px;
        display: inline;
      }

      span {
        font-size: 17px;
      }

      &:hover {
        font-weight: bold;
      }
    }

    .active {
      background: #17a2b8 !important;
      color: #fff;
      box-shadow: 0 0 10px #ccc;
    }
  }

}


.main-exam-right {
  width: 100%;
  float: left;
  min-height: 400px;
  border-top: 1px solid #EEE;
  margin-top: -40px;
  padding-top: 40px;
  padding-bottom: 40px;
}
</style>